import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { TransparentButton, SolidButton } from "../../../../library/button";
import {
  changeContactListsModal,
  requestAddSingleContactList,
} from "../../../../../redux/actions/contact-lists";
import { Input } from "../../../../library/input";
import { Textarea } from "../../../../library/textarea";
import { Popup } from "../../../../library/popup";
import { Label } from "../../../../library/label";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const modalState = useSelector(
    (state) => state.contactLists.showModals.addModal
  );

  const addLoading = useSelector(
    (state) => state.contactLists.addContactList.loading
  );

  const companyId = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );

  const [listDetails, setListDetails] = useState({
    name: null,
    description: null,
  });

  const handleClose = () => {
    dispatch(changeContactListsModal({ addModal: false }));
  };

  const clickAddNewContactList = () => {
    dispatch(
      requestAddSingleContactList({ list: listDetails, companyId: companyId })
    );
  };

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Opprett ny kontaktliste"
      description="Du kan opprette en ny kontaktliste raskt og enkelt ved å fylle inn navn og en valgri beskrivelse."
      buttons={[
        <TransparentButton
          title="Avbryt"
          type="button"
          data-dismiss="modal"
          onClick={() => handleClose()}
        />,
        <SolidButton
          color="blue"
          title={addLoading ? "Legger til.." : "Legg til"}
          icon={
            addLoading ? (
              <i className="fas fa-circle-notch fa-spin"></i>
            ) : (
              <i className="fas fa-plus"></i>
            )
          }
          onClick={() => clickAddNewContactList()}
          type="button"
        />,
      ]}
    >
      <div className="new-contact-list-content-container">
        <Row className="info-row">
          <Col className="info-col">
            <Label version={1} weight="bold">
              Navn *
            </Label>
            <Input
              value={listDetails.name}
              onChange={(e) =>
                setListDetails({ ...listDetails, name: e.target.value })
              }
              placeholder="Navn"
              type="text"
            />
          </Col>
        </Row>
        <Row className="info-row">
          <Col className="info-col">
            <Label version={1} weight="bold">
              Beskrivelse
            </Label>
            <Textarea
              value={listDetails.description}
              onChange={(e) =>
                setListDetails({ ...listDetails, description: e.target.value })
              }
              placeholder="Beskrivelse"
              rows={2}
            />
          </Col>
        </Row>
      </div>
    </Popup>
  );
};

export default Index;
